import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Captain } from 'anchor-shared/lib/model/entity/captain';
import { CaptainDAO } from '../../../../core/services/dao/captainDAO';
import { UserDAO } from '../../../../core/services/dao/userDAO';

@Component({
  selector: 'app-sign-up-availability',
  templateUrl: './sign-up-availability.component.html',
  styleUrls: ['./sign-up-availability.component.scss'],
})
export class SignUpAvailabilityComponent implements OnInit, OnDestroy {
  model: Captain;

  constructor(
    private captainDAO: CaptainDAO,
    private userDAO: UserDAO,
    private router: Router,
  ) {}

  ngOnInit() {
    const user = this.userDAO.getCurrentUser();
    this.model = user.captain;
    console.log(this.model);
  }

  ngOnDestroy(): void {}

  save(waterBodies: any) {
    console.log('save');
    let waterBodyIds = [];
    waterBodies.forEach((waterBody) => {
      waterBodyIds.push(waterBody.id);
    });
    console.log(waterBodyIds);
    this.captainDAO
      .updateUserCaptainWaterBodies(waterBodyIds)
      .subscribe((result) => {
        this.router.navigate(['sign-up/captain-description']);
      });
  }
}
